import * as React from 'react';
const ProfileEditIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#424242" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#171717"
        d="M4.166 15.833h1.052l8.53-8.53-1.051-1.051-8.53 8.53v1.051Zm-1.25 1.25v-2.82L13.91 3.276c.125-.115.265-.203.417-.266a1.25 1.25 0 0 1 .479-.093c.167 0 .329.03.486.089.156.059.295.153.415.282l1.018 1.03c.13.122.222.26.277.418.055.157.082.314.082.471 0 .168-.028.327-.086.48a1.18 1.18 0 0 1-.273.417L5.737 17.084h-2.82ZM13.213 6.786l-.516-.534 1.051 1.05-.535-.516Z"
      />
    </g>
  </svg>
);
export default ProfileEditIcon;
